<template>
  <div
    :class="`${Classes.CONTAINER} tw-w-full tw-flex tw-flex-col tw-items-center`"
  >
    <div class="tw-w-full">
      <slot />
    </div>
  </div>
</template>

<script>
import Classes from '@config/css.js'
export default {
  name: 'ViewContainer',
  setup() {
    return { Classes }
  },
}
</script>
